<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<!-- Spinner is shown at initial load -->
<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h1 class="header-text">Manage Scenario Category / Forecast Gates</h1>
  <div>
    <button (click)="editScenarioCategory()" class="action-button" color="primary"
            id="edit-button"
            [disabled]="selectedValue===''"
            mat-stroked-button>
      Update
    </button>
    <button (click)="addScenarioCategory()" [disabled]="!initialLoad || noData" class="action-button" color="primary"
            id="add-button"
            mat-raised-button>
      Add
    </button>
    <button (click)="deleteScenarioCategory()" class="action-button" color="warn"
            id="delete-button"
            [disabled]="selectedValue===''"
            mat-raised-button>
      Delete
    </button>
  </div>
</div>
<!-- Display message if there is no data -->
<div [hidden]="!noData">No Scenario Categories</div>
<!-- Display table if there is tdata -->
<div class="gfs-table" [hidden]="noData">

  <ag-grid-angular
    style="height: 100%; width:100%;"
    class="ag-theme-quartz"
    [rowData]="scenarioCategories"
    [columnDefs]="columnHeaders"
    [autoSizeStrategy]="autoSizeStrategy"
    [rowSelection]="rowSelection"
    (rowSelected)="onSelect($event)"
  />
</div>
